import { IMAGES } from "../../constant/Image";

const FrequentlyAskedQuestions = () => {
  return (
    <div>

              <section className="faqs-sec">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text">
                        <h2>
                          Frequently Asked <span>Questions</span>{" "}
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Tabs */}
                    <div className="col-md-3">
                      <div className="faqs-left-box">
                        <ul
                          className="nav flex-column nav-pills"
                          id="v-pills-tab"
                          role="tablist"
                        >
                          <li className="nav-item">
                            <button
                              className="nav-link active"
                              id="v-pills-payment-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-payment"
                              type="button"
                            >
                              General
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className="nav-link"
                              id="v-pills-shipping-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-shipping"
                              type="button"
                            >
                              Payment
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className="nav-link"
                              id="v-pills-returns-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#v-pills-returns"
                              type="button"
                            >
                              Bidding
                            </button>
                          </li>
                        </ul>
                        <div className="faqs-email-box">
                          <div className="text">
                            <h4>Ask the help community write now!</h4>
                          </div>
                          <div className="img-box">
                            <img src={IMAGES.email_img} alt="" />
                            <p>To Send Mail</p>
                            <a href="mailto:info@auction.com">info@auction.com</a>
                          </div>
                        </div>
                      </div>
                    </div>
        
                    {/* Tab Content */}
                    <div className="col-md-9">
                      <div className="tab-content" id="v-pills-tabContent">
                        {/* Payment Tab */}
                        <div className="tab-pane fade show active" id="v-pills-payment">
                          <div className="accordion" id="paymentAccordion">
                            {[
                              [
                                "What is an auction?",
                                "Auctions allow items to be sold to the highest bidder. Participants bid on the item until the highest bid is reached within a set timeframe. The highest bidder wins and pays the bid amount.",
                              ],
                              [
                                "How do auctions work?",
                                "lorem lorem",
                              ],
                              [
                                "What types of auctions are there?",
                                "lorem lorem",
                              ],
                              [
                                "Who can participate in auctions?",
                                "lorem lorem",
                              ],
                              [
                                "Are there risks associate with buying at auctions?",
                                "lorem lorem",
                              ],
                            ].map((item, i) => (
                              <div className="accordion-item" key={i}>
                                <h2 className="accordion-header">
                                  <button
                                    className={`accordion-button ${
                                      i !== 0 ? "collapsed" : ""
                                    }`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#paymentCollapse${i}`}
                                  >
                                    {item[0]}
                                    <span className="icon ms-auto"></span>
                                  </button>
                                </h2>
                                <div
                                  id={`paymentCollapse${i}`}
                                  className={`accordion-collapse collapse ${
                                    i === 0 ? "show" : ""
                                  }`}
                                  data-bs-parent="#paymentAccordion"
                                >
                                  <div className="accordion-body">{item[1]}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
        
                        {/* Shipping Tab */}
                        <div className="tab-pane fade" id="v-pills-shipping">
                          <div className="accordion" id="shippingAccordion">
                            {[
                             [
                                "What is an auction?",
                                "Auctions allow items to be sold to the highest bidder. Participants bid on the item until the highest bid is reached within a set timeframe. The highest bidder wins and pays the bid amount.",
                              ],
                              [
                                "How do auctions work?",
                                "lorem lorem",
                              ],
                              [
                                "What types of auctions are there?",
                                "lorem lorem",
                              ],
                              [
                                "Who can participate in auctions?",
                                "lorem lorem",
                              ],
                              [
                                "Are there risks associate with buying at auctions?",
                                "lorem lorem",
                              ],
                            ].map((item, i) => (
                              <div className="accordion-item" key={i}>
                                <h2 className="accordion-header">
                                  <button
                                    className={`accordion-button ${
                                      i !== 0 ? "collapsed" : ""
                                    }`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#shippingCollapse${i}`}
                                  >
                                    {item[0]}
                                    <span className="icon ms-auto"></span>
                                  </button>
                                </h2>
                                <div
                                  id={`shippingCollapse${i}`}
                                  className={`accordion-collapse collapse ${
                                    i === 0 ? "show" : ""
                                  }`}
                                  data-bs-parent="#shippingAccordion"
                                >
                                  <div className="accordion-body">{item[1]}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
        
                        {/* Returns Tab */}
                        <div className="tab-pane fade" id="v-pills-returns">
                          <div className="accordion" id="returnsAccordion">
                            {[
                               [
                                "What is an auction?",
                                "Auctions allow items to be sold to the highest bidder. Participants bid on the item until the highest bid is reached within a set timeframe. The highest bidder wins and pays the bid amount.",
                              ],
                              [
                                "How do auctions work?",
                                "lorem lorem",
                              ],
                              [
                                "What types of auctions are there?",
                                "lorem lorem",
                              ],
                              [
                                "Who can participate in auctions?",
                                "lorem lorem",
                              ],
                              [
                                "Are there risks associate with buying at auctions?",
                                "lorem lorem",
                              ],
                            ].map((item, i) => (
                              <div className="accordion-item" key={i}>
                                <h2 className="accordion-header">
                                  <button
                                    className={`accordion-button ${
                                      i !== 0 ? "collapsed" : ""
                                    }`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#returnsCollapse${i}`}
                                  >
                                    {item[0]}
                                    <span className="icon ms-auto"></span>
                                  </button>
                                </h2>
                                <div
                                  id={`returnsCollapse${i}`}
                                  className={`accordion-collapse collapse ${
                                    i === 0 ? "show" : ""
                                  }`}
                                  data-bs-parent="#returnsAccordion"
                                >
                                  <div className="accordion-body">{item[1]}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        
        
              </section>


   </div>
  );
};

export default FrequentlyAskedQuestions;